<button mat-icon-button class="close-button" (click)="close()">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<h1 matDialogTitle>{{data.title}}</h1>
<div mat-dialog-content>
    <mat-card class="p-0">
        <div fxLayout="row wrap" fxLayout.lt-sm="column">
            <div fxFlex="100">
                <div class="border-top"></div>
            </div>
            <div fxFlex="100" class="toolbar-container" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="8px">


                <mat-form-field appearance="fill" class="search-field" fxFlex="100" fxFlex.gt-xs="45" fxFlex.gt-sm="35">
                    <mat-label>Pesquisar: </mat-label>
                    <input [imask]="maskUpper" matInput placeholder="Pesquisa..." autocomplete="on"
                        (keyup)="searchBy_UsingDebounce($event.target.value)" [(ngModel)]="searchInput"
                        [ngModelOptions]="{standalone: true}">
                    <button mat-button mat-icon-button matSuffix (click)="searchInput='';getPage(1, pageSize)"
                        [color]="'warn'" *ngIf="searchInput">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>

                <mat-form-field appearance="fill" fxFlex="100" fxFlex.gt-xs="24" fxFlex.gt-sm="20">
                    <mat-label>Ordenar</mat-label>
                    <mat-select [(value)]="selectedOrdem" (selectionChange)="searchBy_UsingDebounce(this.searchInput)">
                        <mat-option value="NENHUM">Inclusão</mat-option>
                        <mat-option value="NOME">Nome</mat-option>
                        <mat-option value="TAMANHO">Tamanho</mat-option>
                        <!-- <mat-option value="LOGIN">Último login</mat-option> -->
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="fill" fxFlex="100" fxFlex.gt-xs="24" fxFlex.gt-sm="20">
                    <mat-label>Direção</mat-label>
                    <mat-select [(value)]="selectedDirect" (selectionChange)="searchBy_UsingDebounce(this.searchInput)">
                        <mat-option value="ASC">Ascendente </mat-option>
                        <mat-option value="DESC">Descendente </mat-option>
                    </mat-select>

                </mat-form-field>

                <span fxFlex></span>
                <button mat-icon-button *ngIf="this.view!=='list'"
                    (click)="this.view = 'list'">
                    <mat-icon>view_list</mat-icon>
                </button>

                <button mat-icon-button *ngIf="this.view!=='comfy'"
                    (click)="this.view = 'comfy'">
                    <mat-icon>view_comfy</mat-icon>
                </button>

                <button mat-icon-button *ngIf="this.view!=='module'"
                    (click)="this.view = 'module'">
                    <mat-icon>view_module</mat-icon>
                </button>

                <button mat-raised-button color="primary" class="add-button"
                    (click)="this.openAnexoUploadPopUp(this.lancamento);$event.preventDefault();">
                    <mat-icon>add_circle</mat-icon>
                </button>


            </div>

            <div fxFlex="100">
                <div class="border-top"></div>
            </div>
            <div fxFlex="100">
                <div fxLayout="row wrap">
                    <div *ngFor="let anexo of (this.pageObject$ | async)?.content" fxFlex="{{this.viewSize()}}" fxFlex.xs="100"
                        fxFlex.gt-sm="{{this.viewSize()}}" fxFlex.sm="{{this.viewSize()}}">
                        <mat-card class="user-card p-0">
                            <mat-card-title>
                                <div class="card-title-text">
                                    <div matToolTip="Arquivo">
                                        <a (click)="this.downloadPopUp(anexo)"> {{ anexo?.cadArquivoOnline?.fileName }}
                                        </a>
                                    </div>
                                    <span fxFlex></span>
                                    <button mat-icon-button [matMenuTriggerFor]="userMenu" class="">
                                        <mat-icon class="">more_vert</mat-icon>
                                    </button>
                                    <mat-menu #userMenu="matMenu">

                                        <button mat-menu-item color="primary" class="mr-1" alt="Download"
                                            (click)="this.download(anexo)" routerLinkActive="router-link-active">
                                            <mat-icon color="primary">download</mat-icon>Download
                                        </button>
                                        <button mat-menu-item alt="Deletar" (click)="delete(anexo)">
                                            <mat-icon color="warn">delete</mat-icon>Deletar
                                        </button>
                                    </mat-menu>
                                </div>
                                <mat-divider></mat-divider>
                            </mat-card-title>
                            <mat-card-content>
                                <!-- user detail lines-->
                                <div class="user-details">
                                    Tam. {{anexo?.cadArquivoOnline?.fileSizeToDisplaySize}}
                                </div>
                                <span fxFlex></span>

                                <mat-icon
                                    matTooltip="{{'Enviado por ' + (anexo?.cadArquivoOnline?.createdBy??'Usuário') + ' em ' +  (anexo?.cadArquivoOnline?.issueDate | date: 'dd/MM/yyyy hh:MM:ss')}}"
                                    [matTooltipPosition]="'above'"> info </mat-icon>
                            </mat-card-content>

                        </mat-card>
                    </div>
                    <div fxFlex="100">
                        <mat-paginator #paginator [length]="length" fxLayoutAlign="space-around center"
                            [showFirstLastButtons]="true" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                            (page)="pageEvent = setPageSizeOptions($event)">
                        </mat-paginator>

                    </div>
                </div>
            </div>
        </div>
    </mat-card>
</div>

<mat-dialog-actions>
    <div fxFlex="100" class="mt-1">
        <span fxFlex></span>
        <button mat-button color="warn" type="button" (click)="close()">
            <mat-icon>close</mat-icon>{{"CLOSE" | translate }}
        </button>
    </div>
</mat-dialog-actions>